  var swiper_coll = new Swiper('.swiper-coll', {    
    slidesPerView: 'auto',
    spaceBetween: 17,
    freeMode: true,  
     breakpoints: {
        768: {
          spaceBetween: 55,
        },
      },
  });


 var img_slider = new Swiper('.img_slider', {    
    slidesPerView: 1.15,
    spaceBetween: 10,
   freeMode: false,
   centeredSlides: true,
   loop:false,
   breakpoints: {
        768: {
          freeMode: false,
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: false,
          loop:false,
        },
      },
  });

 var highlights = new Swiper('.highlights', {    
    loop:true,
   slidesPerView: 1.1,
   centeredSlides: false,
   spaceBetween: 10,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
   breakpoints: {
        768: {
          loop:false,
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: false,
        },
      },
  });


 var test_new = new Swiper('.test-new', {  
   slidesPerView: 1.12,
   spaceBetween: 20,
   centeredSlides: true,
   loop:true,
   breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 40,
          loop:false,
          centeredSlides: false,
        },
      },
  });



  var coll_product = new Swiper('.coll_product', {    
    slidesPerView: 'auto',
    spaceBetween: 22,
    freeMode: false,  
    navigation: {
        nextEl: ".swiper-button-next_sec",
        prevEl: ".swiper-button-prev_sec",
      },
  });


 var carousel_img = new Swiper(".carousel_img", {
   cssMode: false,
      pagination: {
        el: ".swiper-pagination",
         clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });





$(document).ready(function() {
  $(window).scroll(function() {
    if ($(document).scrollTop() > 150) {
      $("#SiteHeader").addClass("site-header--stuck site-header--opening");
    } else {
      $("#SiteHeader").removeClass("site-header--stuck site-header--opening");
    }
  });
});